export default {
  sections: {
    order_summary: 'Total de la commande',
  },
  labels: {
    add_items: 'Ajoutez des articles pour commencer',
    item_count_one: '{{count}} article',
    item_count_other: '{{count}} articles',
  },
  buttons: {
    return: 'Retour au récapitulatif',
  },
};
